import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Operators } from "../../../../components/condition/model/Operators";
import { PatchUserGroupMembershipActions } from "./model";

export const ConfirmMembershipController = (userGroupUniqueName) => {
  const dispatch = useDispatch();

  const patchMembershipRequest = useSelector(
    (rootState) => rootState.previewMembership.patchMembershipRequest,
  );
  const { isSpecialConditionChecked, specialConditionNode, action } = useSelector((rootState) => {
    return rootState.keyCondition;
  });
  const userGroup = useSelector(
    (rootState) => rootState.userGroup.userGroupDetails[userGroupUniqueName]?.value,
  );
  const userGroupTypes = useSelector((rootState) => rootState.userGroup.types.value);

  const userGroupName = userGroup.name;
  const userGroupTypeId = userGroup.type;
  const userGroupTypeUniqueName = userGroupTypes[userGroupTypeId].uniqueName;

  const addedPeopleNum = useSelector(
    (rootState) => rootState.previewMembership.previewMembership?.added.value.totalElements,
  );

  const removedPeopleNum = useSelector(
    (rootState) => rootState.previewMembership.previewMembership?.removed.value.totalElements,
  );

  const { value, progress } = useSelector(
    (rootState) =>
      rootState.patchUserGroupMembershipResponse.patchUserGroupMembershipResponse.response,
  );

  const errors = value?.errors;

  const isSpecialCondition =
    isSpecialConditionChecked && specialConditionNode.operator === Operators.comparisonSPECIAL_EQ;

  useEffect(() => {
    dispatch(
      PatchUserGroupMembershipActions.patchUserGroupMembership({
        userGroupUniqueName,
        patchMembershipRequest: patchMembershipRequest,
      }),
    );
  }, [userGroupUniqueName, patchMembershipRequest]);

  return {
    userGroupTypeId,
    removedPeopleNum,
    userGroupName,
    addedPeopleNum,
    isLoading: !!progress,
    errors,
    action,
    isSpecialCondition,
    userGroupTypeUniqueName,
    isNotificationEnabled: () => userGroup.isNotificationEnabled,
  };
};
